import { fetchWrapper } from '../../utils';

export class student {
  static baseUrl = process.env.REACT_APP_BASE_API + 'professor';

  static async createStudent(params) {
    const url = `${this.baseUrl}/students/create`;
    return await fetchWrapper.post(url, params);
  }

  static async getStudents(params) {
    const url = `${this.baseUrl}/students/get`;
    return await fetchWrapper.post(url, params);
  }

  static async getRepresentatives(params) {
    const url = `${this.baseUrl}/get-representatives`;
    return await fetchWrapper.post(url, params);
  }

  static async getProfessorRepresentatives(params) {
    const url = `${this.baseUrl}/get-professor-representatives`;
    return await fetchWrapper.post(url, params);
  }

  static async deleteStudent(params) {
    const url = `${this.baseUrl}/students/destroy`;
    return await fetchWrapper.post(url, params);
  }

  static async updateStudent(params) {
    const url = `${this.baseUrl}/students/update`;
    return await fetchWrapper.post(url, params);
  }

  static downloadEnrolledStudents = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/students/download-enrolled-students', params);
  }

}
